import type { Activity } from '@/types/quiz'

export interface ActivityOption {
  id: Activity
  label: string
  blurb: string
}

/**
 * Screen 1 - Activity. Single-select. Drives the cm cutoff between Short
 * and Regular on Screen 4: ski/snow-play push regular up to 5'3"+, while
 * snowboarders keep it at 5'2"+. Order matters - Snowboard first so the
 * default visual layout reads board ↔ ski ↔ snow play.
 */
export const ACTIVITY_OPTIONS: readonly ActivityOption[] = [
  {
    id: 'snowboard',
    label: 'Snowboarding',
    blurb: 'Strapped in, ready to send it.',
  },
  {
    id: 'ski',
    label: 'Skiing',
    blurb: 'Ready to schuss my day away.',
  },
  {
    id: 'snowplay',
    label: 'Snow play',
    blurb: 'Tobogganing, building snowmen, and a cheeky apres.',
  },
] as const
